var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonutSkeleton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 386,
    viewBox: "0 0 601 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.948242,
    width: 600,
    height: 386,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9736,
    y: 21,
    width: 224.048,
    height: 27,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.448 214C353.448 284.692 296.141 342 225.448 342C154.756 342 97.4482 284.692 97.4482 214C97.4482 143.308 154.756 86 225.448 86C296.141 86 353.448 143.308 353.448 214ZM163.803 214C163.803 248.045 191.403 275.645 225.448 275.645C259.494 275.645 287.093 248.045 287.093 214C287.093 179.955 259.494 152.355 225.448 152.355C191.403 152.355 163.803 179.955 163.803 214Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.448 214C353.448 231.758 349.753 249.322 342.598 265.575C335.443 281.828 324.984 296.414 311.886 308.406C298.789 320.398 283.34 329.533 266.521 335.231C249.702 340.93 231.881 343.066 214.191 341.504C196.502 339.942 179.331 334.717 163.771 326.16C148.21 317.603 134.6 305.902 123.807 291.801C113.013 277.7 105.271 261.507 101.074 244.252C96.8775 226.997 96.3168 209.057 99.4282 191.574L164.757 203.199C163.259 211.619 163.529 220.259 165.55 228.569C167.571 236.879 171.299 244.678 176.498 251.469C181.696 258.26 188.25 263.895 195.744 268.016C203.238 272.137 211.508 274.654 220.027 275.406C228.546 276.158 237.129 275.129 245.229 272.385C253.329 269.641 260.769 265.241 267.077 259.466C273.385 253.69 278.422 246.666 281.868 238.838C285.313 231.011 287.093 222.552 287.093 214H353.448Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.448 214C353.448 234.49 348.529 254.68 339.105 272.874C329.681 291.068 316.026 306.733 299.29 318.553C282.553 330.374 263.224 338.003 242.926 340.801C222.628 343.599 201.955 341.483 182.645 334.631L204.834 272.096C214.134 275.396 224.09 276.415 233.866 275.067C243.641 273.72 252.95 270.046 261.01 264.353C269.071 258.66 275.647 251.116 280.185 242.354C284.724 233.592 287.093 223.868 287.093 214H353.448Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M353.448 214C353.448 230.809 350.137 247.454 343.705 262.983C337.272 278.513 327.844 292.624 315.958 304.51L269.038 257.589C274.762 251.865 279.303 245.07 282.401 237.59C285.499 230.111 287.093 222.095 287.093 214H353.448Z",
    fill: "#F0F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 17,
    transform: "translate(383.448 165)",
    fill: "#F0F0F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 17,
    transform: "translate(383.448 192)",
    fill: "#F0F0F0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 17,
    transform: "translate(383.448 219)",
    fill: "#F0F0F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 17,
    transform: "translate(383.448 246)",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutSkeleton);
export default __webpack_public_path__ + "static/media/DonutSkeleton.3b91d77d6b8ec718a383e413e9441057.svg";
export { ForwardRef as ReactComponent };